import { render } from "./SentimentsPage.vue?vue&type=template&id=c8beeab6"
import script from "./SentimentsPage.vue?vue&type=script&lang=js"
export * from "./SentimentsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__